function getExportFieldTypeForType(type) {
  return `attr.exportField.${type}`;
}
export default {
  getExportFieldTypeForType
};